import { parseDate } from '@superdispatch/dates';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useJSONLocalStore } from 'shared/helpers/Store';

const REPORTED_SHIPPERS_SESSION_STORAGE_KEY = 'reported_shippers';

export function useReportedShippers() {
  const { storeValue, updateStoreValue } = useJSONLocalStore<
    Record<string, string>
  >(REPORTED_SHIPPERS_SESSION_STORAGE_KEY, {});

  return useMemo(() => {
    const oneDayBeforeNow = DateTime.local().minus({ days: 1 });
    return {
      // guids of shippers that wa reported less than one day ago
      reportedShippersGUIDs: Object.entries(storeValue)
        .filter((guids) => parseDate(guids[1]) > oneDayBeforeNow)
        .map((guids) => guids[0]),
      addReportedShipperGUID: (guid: string) => {
        updateStoreValue((prev) => {
          return { ...prev, [guid]: DateTime.local().toString() };
        });
      },
    };
  }, [storeValue, updateStoreValue]);
}
